<template>
  <div class="row add-campaign">
    <div class="columns medium-4 small-12">
      <AddBasicCampaign
        class="add-campaign__box"
        @add="onAddCampaign(campaignTypes.BASIC)"
      />
    </div>

    <div class="columns medium-4 small-12">
      <AddSearchCampaign
        class="add-campaign__box"
        @add="onAddCampaign(campaignTypes.SEARCH)"
      />
    </div>

    <div class="columns medium-4 small-12">
      <AddDiscoveryCampaign
        class="add-campaign__box"
        @add="onAddCampaign(campaignTypes.DISCOVERY)"
      />
    </div>
  </div>
</template>

<script>
import AddSearchCampaign from './AddSearchCampaign';
import AddDiscoveryCampaign from './AddDiscoveryCampaign';
import AddBasicCampaign from './AddBasicCampaign';

import { campaignTypes } from '../common/constants.js';

export default {
  name: 'AddCampaign',
  components: {
    AddSearchCampaign,
    AddDiscoveryCampaign,
    AddBasicCampaign,
  },
  computed: {
    campaignTypes() {
      return campaignTypes;
    },
  },
  methods: {
    onAddCampaign(campaignType) {
      const { SEARCH, DISCOVERY, BASIC } = campaignTypes;
      if (
        campaignType === DISCOVERY ||
        campaignType === SEARCH ||
        campaignType === BASIC
      ) {
        this.$emit('add', campaignType);
      }
    },
  },
};
</script>

<style lang="scss">
.add-campaign {
  &__box {
    height: 100%;
    padding-bottom: $global-margin;
  }
}
</style>
